import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import de from './de.json';
import en from './en.json';
import { zodI18nMap } from 'zod-i18n-map';
import { z } from 'zod';
import germanTranslation from 'zod-i18n-map/locales/de/zod.json';
import englishTranslation from 'zod-i18n-map/locales/en/zod.json';
const languages = ['en', 'de', 'fi'];

const savedLang = window.localStorage.getItem('i18nextLng');

export const resources = {
  en: {
    translation: en,
    zod: englishTranslation,
  },
  de: {
    translation: de,
    zod: germanTranslation,
  },
};

i18n.use(initReactI18next).init({
  lng: savedLang ?? 'de',
  supportedLngs: languages,
  debug: false,
  fallbackLng: 'de',
  // Texterify exports untranslated keys as EMPTY STRINGS, and i18next's default
  // (returnEmptyString: true) hands that empty string back as a valid translation instead of
  // falling back. Any not-yet-translated key therefore rendered as blank UI — a label-less button
  // reads as "the feature isn't there". Treat empty as missing so it falls back to German.
  returnEmptyString: false,
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  resources,
});

z.setErrorMap(zodI18nMap);

export default i18n;
